export default "__VITE_ASSET__5f172ecb__"